import Modal from "./Modal";
import ModalBody from "./ModalBody";
import ModalFooter from "./ModalFooter";
import ModalHeader from "./ModalHeader";

export default Modal;
export { ModalBody, ModalFooter, ModalHeader };
